export default __webpack_public_path__ + "static/media/search_icon.582e6fda.svg";